import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LegacyNavigateService {

  constructor() { }

  private bridge() {
    return (window as any).KO_NAVIGATE_BRIDGE;
  }

  to(settings?) {
    return this.bridge().to(settings);
  }

  toNewWindow (settings) {
    return this.bridge().toNewWindow(settings);
  }

  toPopupWindow(url) {
    return this.bridge().toPopupWindow(url);
  }

  showArticle (articleId) {
    return this.bridge().showArticle(articleId);
  }

  viewAttachment(attachmentId) {
    return this.bridge().viewAttachment(attachmentId);
  }

  canGoBack() {
    return this.bridge().canGoBack();
  }

  backFromDelete(tableId) {
    return this.bridge().backFromDelete(tableId);
  }

  stackTop() {
    return this.bridge().stackTop();
  }

  removeFromStack(tableId) {
    return this.bridge().removeFromStack();
  }

  back(settings?) {
    return this.bridge().back(settings);
  }

  rightSlideInWindow(tileSettings?, callback?) {
    return this.bridge().rightSlideInWindow(tileSettings, callback);
  }

  preview(
    tableName: string,
    tableId: string,
    options?: {
      aspect?: string,
      focusField?: string
    },
    callback?: (eventData, envelope) => void) {
    const view = "Popout" + tableName;
    this.rightSlideInWindow(
      {
        'tile': 'DetailsAutoScaffold',
        'parameter-values': {
          table: tableName,
          id: tableId,
          aspect: options?.aspect,
          view: view,
          focusField: options?.focusField
        },
        'loadOptions': {
          cache: false,
          popup: true
        }
      },
      callback);
  }

  modalForm(tileSettings?, callback?) {
    return this.bridge().modalForm(tileSettings, callback);
  }

  closeModalForm(data?) {
    return this.bridge().closeModalForm(data);
  }

  progressForm(options?) {
    return this.bridge().progressForm(options);
  }

  hideRightSlideInPanel() {
    return this.bridge().hideRightSlideInPanel();
  };

  getFormContextForElement(element) {
    return this.bridge().getFormContextForElement(element);
  };
}
